import { StyleColorSchemeType, StyleSizeType } from '../../../styles/enums';
import { StyleFillType } from '../../input/enums';
import { DATA_OPTION_PLACEHOLDER } from '../constants';
import { MultiSelectProperty } from '../enums';

const MultiSelectProps = {
  props: {
    [MultiSelectProperty.Value]: {
      default: () => [],
      type: Array,
    },
    [MultiSelectProperty.Label]: {
      default: '',
      type: String,
    },
    [MultiSelectProperty.Id]: {
      default: '',
      type: String,
    },
    [MultiSelectProperty.Options]: {
      default: () => [],
      type: Array,
    },
    [MultiSelectProperty.NoOptionsPlaceholder]: {
      default: DATA_OPTION_PLACEHOLDER,
      type: String,
    },
    [MultiSelectProperty.CheckboxIconSize]: {
      default: StyleSizeType.Medium,
      type: String,
    },
    [MultiSelectProperty.IconColor]: {
      default: StyleColorSchemeType.Secondary,
      type: String,
    },
    [MultiSelectProperty.ColorScheme]: {
      default: StyleColorSchemeType.SecondaryLight,
      type: String,
    },
    [MultiSelectProperty.LabelColorScheme]: {
      default: StyleColorSchemeType.Primary,
      type: String,
    },
    [MultiSelectProperty.FillType]: {
      default: StyleFillType.Underlined,
      type: String,
    },
    [MultiSelectProperty.Disabled]: {
      default: false,
      type: Boolean,
    },
    [MultiSelectProperty.IsReadonly]: {
      default: true,
      type: Boolean,
    },
    [MultiSelectProperty.ErrorMessage]: {
      default: '',
      type: String,
    },
    [MultiSelectProperty.IsShowErrorMessage]: {
      default: false,
      type: Boolean,
    },
  },
};

export default MultiSelectProps;
